import { useTheme } from './ThemeContext';
import { getTokens } from './tokens';
import { CHART_PALETTE } from './dataViz';

export const useChartTokens = () => {
  const { theme } = useTheme();
  const t = getTokens(theme);
  return {
    palette: CHART_PALETTE[theme] || CHART_PALETTE.dark,
    gridStroke: t.borderSubtle,
    axisFill: t.inkSecondary,
    tooltipStyle: {
      background: t.surfaceRaised,
      border: `1px solid ${t.borderSubtle}`,
      color: t.inkPrimary,
    },
    tooltipLabelStyle: { color: t.inkPrimary },
    tooltipItemStyle: { color: t.inkSecondary },
    legendStyle: { color: t.inkSecondary, fontSize: 11 },
  };
};
